/* ==========================================================================
   pdp-swatch-medida.js  --  MAHA  --  2026-09-02
   --------------------------------------------------------------------------
   QUE HACE
   Swatch King pinta bajo cada muestra el valor de opcion COMPLETO. Como en MAHA
   la medida va al final ("Plato Trinche 27 cm"), y el preset recorta por la
   derecha con ellipsis a 89 px, la etiqueta nativa acaba ensenando
   "Plato Trinche ..." y escondiendo justo el dato que interesa.

   Este archivo reduce ese texto a su medida: "27 cm", "450 ml", "36x24 cm".
   Cabe en un renglon, no hay que envolver, y el crecimiento vertical se queda
   en el que ya se midio.

   COMO LO HACE  --  la regla de esta tarea
   Anade un <span data-maha-medida> HERMANO del <p> de la app, dentro del mismo
   contenedor. NO toca el <p>, ni su class, ni data-value, ni ningun atributo
   ARIA, ni el <li>, ni el <ul>. El <p> se oculta desde CSS
   (assets/pdp-swatch-medida.css), no desde aqui.

   NO SE CITA NINGUN IDENTIFICADOR INESTABLE. Ni `swatch-preset-744259` (id de
   fila del preset en la BD de la app) ni `data-group-index` (es la POSICION del
   grupo entre los que haya: anadir uno los corre todos). Solo el nombre del
   custom element y las clases funcionales.

   EL TOPE NO SE DUPLICA AQUI
   El umbral de "3 o mas grupos" vive UNA sola vez, en el selector raiz de
   assets/pdp-swatch-medida.css. Este archivo no lo reimplementa: lo consulta,
   leyendo la custom property `--maha-destapa` que aquella hoja publica sobre el
   `.swatch-single` destapado. Si no vale 1, aqui no se escribe nada y se retira
   cualquier <span> anterior. Ver funcion `destapado()`.

   DEGRADACION SEGURA
   - Si la app deja de emitir `.swatch-img-text-adjacent`, no hay donde escribir:
     no se anade nada, y el CSS tampoco casa. Queda la ficha de hoy.
   - Si algo lanza, se traga en un try/catch por pasada. Un throw suelto en esta
     pagina puede cortar a otros suscriptores (FoxTheme.pubsub.publish no lleva
     try/catch propio), asi que aqui nada escapa.
   - Si ningun patron casa, NO se recorta: se deja el valor completo de la app.
     Un color nunca se convierte en cifra.

   NO PUEDE ROMPER EL SELECTOR
   El manejador de la app hace `for (t = e.target; t.hasAttribute("swatch-inside");)
   t = t.parentNode;`. Por eso el <span> lleva swatch-inside="true": si alguna vez
   fuera el blanco del clic, la app sube al nodo correcto igual que con el <p>.
   Ademas el CSS le pone pointer-events:none, asi que en la practica nunca lo es.
   ========================================================================== */
(function () {
  'use strict';

  var RAIZ = 'variant-swatch-king';
  var CONTENEDOR = '.swatch-img-text-adjacent';
  var MARCA = 'data-maha-medida';
  var ORIGEN = 'data-maha-src';

  /* ------------------------------------------------------------------------
     LA GUARDIA: un valor con LISTA de numeros no se recorta NUNCA.
     "Tapa domo con perforacion 9, 12, 16 y 20 oz" no mide 20 oz: son cuatro
     calibres. Recortarlo seria decir algo falso, que es peor que no decir nada.
     Tambien atrapa los separadores de millar y las comas decimales mal escritas
     ("Caja 2, 45 oz / 1,330 ml"), donde tampoco hay una medida limpia que sacar.

     Se admiten hasta 6 caracteres no numericos entre los dos numeros, para que
     tambien caiga "450 ml / 15 oz) y 350 ml" -- una lista de verdad, con la
     unidad de por medio. La barra "/" NO cuenta como separador de lista: separa
     la MISMA medida en dos unidades ("40.5 cm / 16\"") y ademas aparece en las
     fracciones de pulgada ("12 1/2\"").
     ------------------------------------------------------------------------ */
  var LISTA = /\d[^\d]{0,6}?(?:,|\by\b)[^\d]{0,6}?\d/i;

  /* Segunda guardia: VARIAS MEDIDAS SUELTAS.
     El texto de una muestra de grupo puede ser el titulo entero del producto
     ("... Alto 5.5 cm, largo 21 cm, ancho 7 cm"). Ahi no hay "una" medida: hay
     tres, y quedarse con la primera dice "5.5 cm" de una caja de 21 cm. Regla:
     si aparecen DOS O MAS pares numero+longitud, no se recorta.
     Ojo: "Charola 28 x 18.5 cm" tiene un solo par (la unidad va una sola vez),
     asi que las medidas compuestas P1/P2 siguen pasando. */
  var LONGITUDES = /(\d+(?:[.]\d+)?)\s*(cm|mm)\b/gi;
  /* Y si se repite la MISMA unidad de volumen son dos capacidades distintas,
     no una equivalencia: "30 OZ / 1 L" si es la misma medida en dos unidades y
     debe pasar; "500 ml ... 225 ml" no. */
  var VOLUMENES = /(\d+(?:[.]\d+)?)\s*(ml|lts|lt|l|oz|onzas|onza)\b/gi;

  function variasMedidas(s) {
    var m, nLong = 0, unidades = {};
    LONGITUDES.lastIndex = 0;
    while ((m = LONGITUDES.exec(s)) !== null) nLong++;
    if (nLong >= 2) return true;
    VOLUMENES.lastIndex = 0;
    while ((m = VOLUMENES.exec(s)) !== null) {
      var u = m[2].toLowerCase();
      if (u === 'onza' || u === 'onzas') u = 'oz';
      if (u === 'lts' || u === 'lt') u = 'l';
      unidades[u] = (unidades[u] || 0) + 1;
      if (unidades[u] >= 2) return true;
    }
    return false;
  }

  /* ------------------------------------------------------------------------
     LOS PATRONES, en orden de aplicacion: el primero que casa, gana.
     Las medidas compuestas van ANTES que las simples, porque "33x33x2 cm" con
     una regla de numero suelto devuelve "2".
     Cobertura medida sobre los 1,114 valores de opcion que la app pinta como
     muestra: 83.4 %.
     ------------------------------------------------------------------------ */
  var PATRONES = [
    /* P1  3D   "Tabla para picar Amarilla 45 x 30 x 1.27 cm"  -> 45 x 30 x 1.27 cm */
    { id: 'P1', re: /(\d+(?:[.]\d+)?)\s*[x×]\s*(\d+(?:[.]\d+)?)\s*[x×]\s*(\d+(?:[.]\d+)?)\s*(cm|mm)\b/i, tipo: 'bloque' },
    /* P2  2D   "Plato ovalado 36x24 cm"                        -> 36x24 cm        */
    { id: 'P2', re: /(\d+(?:[.]\d+)?)\s*[x×]\s*(\d+(?:[.]\d+)?)\s*(cm|mm)\b/i, tipo: 'bloque' },
    /* P5  longitud  "Plato Trinche 27 cm" / "Frasco 26.7 cm"   -> 27 cm / 26.7 cm */
    { id: 'P5', re: /(\d+(?:[.]\d+)?)\s*(cm|mm)\b/i, tipo: 'num_unidad' },
    /* P4  volumen   "Frasco 50 ML" / "Tazon 450 ml"            -> 50 ml / 450 ml  */
    { id: 'P4', re: /(\d+(?:[.]\d+)?)\s*(ml|lts|lt|l)\b/i, tipo: 'num_unidad' },
    /* P6  onzas     "Vaso 16 oz"                               -> 16 oz           */
    { id: 'P6', re: /(\d+(?:[.]\d+)?)\s*(oz|onzas|onza)\b/i, tipo: 'num_unidad' },
    /* P7  pulgadas  'Inserto profundidad 2.5"' / '12 1/2"'     -> 2.5" / 12 1/2"  */
    { id: 'P7', re: /(\d+(?:\s+\d+\/\d+)?|\d+\/\d+)\s*(?:"|''|pulg\.?|in\b)/, tipo: 'bloque' }
  ];

  /* El simbolo del litro va en mayuscula ("1 L"); el resto, en minuscula. */
  function unidad(u) {
    var b = String(u).toLowerCase();
    if (b === 'l' || b === 'lt' || b === 'lts') return 'L';
    if (b === 'onza' || b === 'onzas') return 'oz';
    return b;
  }

  /**
   * Reduce un valor de opcion a su medida.
   * @returns {string|null} la medida, o null si no hay que recortar.
   */
  function recorta(valorCrudo) {
    /* doble espacio y saltos: el catalogo trae "Plato trinche  Horeca 20 cm" */
    var s = String(valorCrudo || '').replace(/\s+/g, ' ').trim();
    if (!s) return null;
    if (LISTA.test(s)) return null;                 /* las guardias, antes que nada */
    if (variasMedidas(s)) return null;

    for (var i = 0; i < PATRONES.length; i++) {
      var p = PATRONES[i];
      var m = s.match(p.re);
      if (!m) continue;
      var salida;
      if (p.tipo === 'num_unidad') {
        salida = m[1] + ' ' + unidad(m[2]);          /* "50 ML" -> "50 ml", "1 l" -> "1 L" */
      } else {
        salida = m[0].replace(/\s+/g, ' ').trim();
        salida = salida.replace(/(cm|mm)$/i, function (u) { return u.toLowerCase(); });
        salida = salida.replace(/\s*X\s*/g, ' x ').replace(/\s+/g, ' ').trim();
      }
      /* si el recorte no ahorra nada, no vale la pena sustituir nada */
      if (salida.length >= s.length) return null;
      return salida;
    }
    return null;
  }

  /* ------------------------------------------------------------------------
     Pintado. Idempotente: si el <span> ya existe y su origen coincide con el
     texto actual del <p>, no se toca. Asi la propia escritura no se realimenta
     a traves del MutationObserver.
     ------------------------------------------------------------------------ */
  function pinta(raiz) {
    var selectores = raiz.querySelectorAll('.swatch-single');
    for (var i = 0; i < selectores.length; i++) pintaSelector(selectores[i]);
  }

  /**
   * ¿Este selector esta destapado?
   * NO se reimplementa aqui el umbral de los grupos: se CONSULTA el que decidio
   * assets/pdp-swatch-medida.css, que lo escribe una sola vez y lo publica en la
   * custom property `--maha-destapa`. Asi CSS y JS no pueden discrepar, y si
   * manana el tope cambia, se cambia solo en la hoja.
   * Si el CSS no cargo, o la ficha esta capada, o el navegador no soporta :has()
   * ni la anidacion, la propiedad viene vacia y aqui no se escribe nada -- que es
   * exactamente lo que hay que hacer: sin destape, un <span> nuestro solo serviria
   * para apagar el <p> de la app y encoger el bloque.
   */
  function destapado(selector) {
    try {
      return window.getComputedStyle(selector).getPropertyValue('--maha-destapa').trim() === '1';
    } catch (e) {
      return false;
    }
  }

  function limpia(selector) {
    var previos = selector.querySelectorAll('[' + MARCA + ']');
    for (var i = 0; i < previos.length; i++) {
      if (previos[i].parentNode) previos[i].parentNode.removeChild(previos[i]);
    }
  }

  function pintaSelector(selector) {
    var conts = selector.querySelectorAll(CONTENEDOR);
    if (!conts.length) return;

    if (!destapado(selector)) { limpia(selector); return; }

    var items = [], vistos = {}, choca = false, i, it;

    for (i = 0; i < conts.length; i++) {
      var p = conts[i].querySelector('p');           /* solo LECTURA del <p> */
      if (!p) continue;
      var valor = p.textContent;
      var medida = recorta(valor);
      if (medida !== null) {
        if (vistos[medida]) choca = true;
        vistos[medida] = true;
      }
      items.push({ cont: conts[i], valor: valor, medida: medida });
    }

    /* TERCERA GUARDIA: la etiqueta esta para DISTINGUIR una muestra de otra.
       Si dos muestras del MISMO selector se recortarian al mismo texto, el
       recorte deja de servir. Pasa en los grupos de color: "Plato trinche rosa
       Mexico Lindo 27 cm", "... morado ...", "... azul ..." dan las tres
       "27 cm". Cuando eso ocurre no se recorta NINGUNA de ese selector y se
       ven los valores completos, con su color. */
    for (i = 0; i < items.length; i++) {
      it = items[i];
      var salida = choca ? null : it.medida;
      var span = it.cont.querySelector('[' + MARCA + ']');

      if (salida === null) {
        /* nada que recortar: se retira nuestro hermano si lo hubiera, y la
           etiqueta nativa vuelve a verse entera (D4) */
        if (span && span.parentNode) span.parentNode.removeChild(span);
        continue;
      }
      if (span && span.getAttribute(ORIGEN) === it.valor) continue;

      if (!span) {
        span = document.createElement('span');
        span.setAttribute(MARCA, '');
        /* la app sube por el DOM mientras el nodo tenga este atributo */
        span.setAttribute('swatch-inside', 'true');
        /* el nombre accesible ya lo dan li[aria-label] y span[role=img]:
           el recorte es decoracion visual, no debe leerse dos veces */
        span.setAttribute('aria-hidden', 'true');
        it.cont.appendChild(span);
      }
      span.setAttribute(ORIGEN, it.valor);
      span.setAttribute('title', String(it.valor).trim());
      span.textContent = salida;
    }
  }

  /* ------------------------------------------------------------------------
     Enganche. Un MutationObserver por cada <variant-swatch-king>, que es el
     unico ancla estable. Nada de presets ni de indices de grupo.
     ------------------------------------------------------------------------ */
  var pendiente = false;

  function programa() {
    if (pendiente) return;
    pendiente = true;
    var luego = function () { pendiente = false; pasada(); };
    /* rAF llamado sin su receptor lanza "Illegal invocation" en varios motores */
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(luego);
    } else {
      window.setTimeout(luego, 16);
    }
  }

  function pasada() {
    try {
      var raices = document.querySelectorAll(RAIZ);
      for (var i = 0; i < raices.length; i++) pinta(raices[i]);
    } catch (e) {
      /* silencio deliberado: nada de lo que pase aqui puede tumbar la PDP */
    }
  }

  function observa(nodo) {
    if (nodo.__mahaMedidaObs) return;
    nodo.__mahaMedidaObs = true;
    try {
      new MutationObserver(programa).observe(nodo, { childList: true, subtree: true });
    } catch (e) { /* sin observer, al menos queda la pasada inicial */ }
  }

  function conecta() {
    var raices = document.querySelectorAll(RAIZ);
    for (var i = 0; i < raices.length; i++) observa(raices[i]);
    return raices.length;
  }

  function arranca() {
    try {
      if (conecta() === 0) {
        /* el custom element aun no esta en el DOM: se espera a que aparezca,
           y el vigia se apaga en cuanto lo encuentra */
        var vigia = new MutationObserver(function () {
          if (conecta() > 0) { vigia.disconnect(); programa(); }
        });
        vigia.observe(document.documentElement, { childList: true, subtree: true });
        /* red de seguridad: el vigia no se queda encendido para siempre */
        setTimeout(function () { try { vigia.disconnect(); } catch (e) {} }, 30000);
      }
      pasada();
    } catch (e) { /* silencio deliberado */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }
})();
